import {
  type AggregatedResponse,
  createAction,
  handleAggregatorResponse,
} from '@wix/communities-blog-client-common';
import { getQueryLocale } from '../../common/selectors/locale-selectors';
import type { TagCloudThunkAction, TagCloudView } from '../types';

type TagCloudRenderModelResponse = {
  tagCloud: AggregatedResponse<TagCloudView>;
};

export const fetchTagCloudWidgetInitialData =
  (): TagCloudThunkAction =>
  async (dispatch, getState, { aggregatorRequest }) => {
    const langQuery = getQueryLocale(getState());
    const language = langQuery ? `&language=${langQuery}` : '';

    const response = await aggregatorRequest<TagCloudRenderModelResponse>(
      `/v1/tag-cloud-widget/render-model?onlyWithPublishedPosts=true${language}`,
      {
        throwOnInvalidJson: true,
      },
    );

    try {
      const tagCloud = await dispatch(
        handleAggregatorResponse(response.tagCloud),
      );
      dispatch(tagCloudWidgetSuccess(tagCloud));
    } catch (error) {
      console.error(error);
      tagCloudWidgetFailure();
    }
  };

export const tagCloudWidgetSuccess = createAction(
  'tagCloudWidget/SUCCESS',
  (payload: TagCloudView) => payload,
);
const tagCloudWidgetFailure = createAction('tagCloudWidget/FAILURE', () => {});
